import React, { useState, useEffect } from 'react';
import './OptimizedImage.css';

const OptimizedImage = ({ src, alt, className, loading = 'lazy' }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (loading === 'lazy') {
      // Usar IntersectionObserver para lazy loading
      const img = new Image();
      const handleLoad = () => {
        setImageSrc(src);
        setIsLoaded(true);
      };
      const handleError = () => {
        setError(true);
        setImageSrc(src); // Mostrar a imagem mesmo com erro
      };

      img.onload = handleLoad;
      img.onerror = handleError;
      img.src = src;
    } else {
      // Carregamento imediato
      setImageSrc(src);
    }
  }, [src, loading]);

  return (
    <picture className={`optimized-image ${isLoaded ? 'loaded' : ''} ${error ? 'error' : ''}`}>
      <img
        src={imageSrc}
        alt={alt}
        className={className}
        decoding="async"
        loading={loading}
      />
    </picture>
  );
};

export default OptimizedImage;
